import {integrationConstants} from "../constants/integrationConstants";
import {alertActions} from "./alertActions";
import {integrationService} from "../../service/integrationService";

export const integrationActions = {
    getFacebookLoginLink,
    facebookCallback,
    getFacebookAdAccounts,
    integrateFacebookAdAccount,
    integrateFacebookConversionAPI,
    getTrafficSourceIntegrations,
    getAffiliateNetworkIntegrations,
    deleteIntegration,
    enableDataTransfer,
    getRenewableFacebookLoginLink,
    updateStep,
    updateSelectedIntegration,
    rerender,
    reset,
    createPushGroundIntegration,
    findIntegration,
    updatePushGroundIntegration,
    createPropellerAdsIntegration,
    updatePropellerAdsIntegration,
    createExoClickIntegration,
    updateExoClickIntegration,
    createMondiadIntegration,
    updateMondiadIntegration,
    createClickBankIntegration,
    updateClickBankIntegration,
    createSedoIntegration,
    updateSedoIntegration,
    createSystem1Integration,
    updateSystem1Integration,
    getGoogleLoginLink,
    getRenewableGoogleLoginLink,
    googleCallback,
    getGoogleAdAccounts,
    integrateGoogleAdAccount,
    integrateGoogleConversionAPI,
    getMicrosoftLoginLink,
    microsoftCallback,
    getRenewableMicrosoftLoginLink,
    getMicrosoftAdAccounts,
    integrateMicrosoftAdAccount,
    integrateMicrosoftConversionAPI,
    createBodisIntegration,
    updateBodisIntegration,
    createDomainActiveIntegration,
    updateDomainActiveIntegration,
    createAdsComIntegration,
    updateAdsComIntegration,
    createTonicIntegration,
    updateTonicIntegration,
    createShopifyIntegration,
    updateShopifyIntegration,
    getTaboolaAdAccounts,
    createTaboolaIntegration,
    updateTaboolaIntegration,
    createMgidIntegration,
    updateMgidIntegration,
    createOutbrainIntegration,
    updateOutbrainIntegration,
    getOutbrainAdAccounts,
    getTikTokLoginLink,
    getRenewableTikTokLoginLink,
    tikTokCallback,
    getTikTokAdAccounts,
    integrateTikTokAdAccount,
    integrateTikTokConversionAPI,
    getRsocIntegrations,
    getServerIntegrations,
    createRsocSystem1Integration,
    updateRsocSystem1Integration,
    createRsocInuvoIntegration,
    updateRsocInuvoIntegration,
    createServerAwsIntegration,
    updateServerAwsIntegration,
    createDomainCloudflareIntegration,
    updateDomainCloudflareIntegration,
    createDomainNamesiloIntegration,
    updateDomainNamesiloIntegration,
    createRsocAMGIntegration,
    updateRsocAMGIntegration,
    createRevContentIntegration,
    updateRevContentIntegration,
    createRsocAdsComIntegration,
    updateRsocAdsComIntegration,
    createRsocPredictoIntegration,
    updateRsocPredictoIntegration,
    createRsocAirfindIntegration,
    updateRsocAirfindIntegration,
    createRsocPricesIntegration,
    updateRsocPricesIntegration,
    createRsocInuvoPrismIntegration,
    updateRsocInuvoPrismIntegration,
    createRsocTonicIntegration,
    updateRsocTonicIntegration,
    createRsocExploradsIntegration,
    updateRsocExploradsIntegration,
    createRsocSedoIntegration,
    updateRsocSedoIntegration,
    createRsocVisymoIntegration,
    updateRsocVisymoIntegration,
    createOutbrainDSPIntegration,
    updateOutbrainDSPIntegration,
    getOutbrainDSPAdAccounts,
    getNewsBreakAdAccounts,
    createNewsBreakIntegration,
    updateNewsBreakIntegration,
    smartNewsSetActiveStep,
    smartNewsConnect,
    getSmartNewsAdAccounts,
    integrateSmartNewsAdAccount,
    integrateSmartNewsConversionAPI,
    createMediaGoIntegration,
    updateMediaGoIntegration,
    getMediaGoAdAccounts,
    createPopinIntegration,
    updatePopinIntegration,
    removeIntegrationEventFromCurrentIntegration,
};

function getFacebookLoginLink(renewIntegrationId) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_FB_LOGIN_LINK_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getFacebookLoginLink(renewIntegrationId)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_FB_LOGIN_LINK, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function getRenewableFacebookLoginLink(renewIntegrationId) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_INTEGRATIONS_VIEW_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getFacebookLoginLink(renewIntegrationId)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_RENEWABLE_FB_LOGIN_LINK, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function facebookCallback(code, state) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.facebookCallback(code, state)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error("Facebook integration failed: " + error?.response?.data?.error));
            }
        );
    };
}

function getFacebookAdAccounts(id) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AD_ACCOUNTS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getFacebookAdAccounts(id)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_AD_ACCOUNTS, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function integrateFacebookAdAccount({adAccountId, integrationId}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AD_ACCOUNTS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.integrateFacebookAdAccount({adAccountId, integrationId})
            .then(() => {
                integrationService.getFacebookAdAccounts(integrationId)
                    .then((result) => {
                        dispatch({type: integrationConstants.INTEGRATIONS_SET_AD_ACCOUNTS, result});
                    }).catch((error) => {
                        dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                        dispatch(alertActions.error(error?.response?.data?.error));
                    }
                );
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error("Facebook ad account integration failed: " + error?.response?.data?.error));
            }
        );
    };
}

function integrateFacebookConversionAPI({integrationId = 0, enableConversionAPI = false, events = [], pixels = []}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.integrateFacebookConversionAPI({
            integrationId, enableConversionAPI, events, pixels
        }).then(() => {
            dispatch(alertActions.success("Facebook (Meta) Ads is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("Facebook (Meta) Ads integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function getTrafficSourceIntegrations() {
    return (dispatch, getState) => {
        if (getState().integration.loading.integrations) return;
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_INTEGRATIONS_SPINNER});
        integrationService.getIntegrations({category: "traffic-source"})
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_INTEGRATIONS, result});
            }).catch((error) => {
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function getAffiliateNetworkIntegrations() {
    return (dispatch, getState) => {
        if (getState().integration.loading.affiliateNetworkIntegrations) return;
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AFFILIATE_NETWORK_INTEGRATIONS_SPINNER});
        integrationService.getIntegrations({category: "affiliate-network"})
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_AFFILIATE_NETWORK_INTEGRATIONS, result});
            }).catch((error) => {
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function deleteIntegration(integrationId) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_INTEGRATIONS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.deleteIntegration(integrationId).then(() => {
            dispatch({type: integrationConstants.INTEGRATIONS_RESET});
        }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function enableDataTransfer(integrationId, enableDataTransfer) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_INTEGRATIONS_VIEW_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.enableDataTransfer(integrationId, enableDataTransfer).then(() => {
            dispatch({type: integrationConstants.INTEGRATIONS_UPDATE_DATA_TRANSFER_STATUS, integrationId});
        }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function updateStep(formStep) {
    return dispatch => {
        dispatch({type: integrationConstants.INTEGRATIONS_UPDATE_STEP, formStep});
    };
}

function updateSelectedIntegration(selectedIntegration) {
    return dispatch => {
        dispatch({type: integrationConstants.INTEGRATIONS_UPDATE_SELECTED_INTEGRATION, selectedIntegration});
    };
}

function rerender() {
    return dispatch => {
        dispatch({type: integrationConstants.INTEGRATIONS_RERENDER});
    };
}

function reset() {
    return dispatch => {
        dispatch({type: integrationConstants.INTEGRATIONS_RESET});
    };
}

function createPushGroundIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createPushGroundIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function updatePushGroundIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updatePushGroundIntegration(id, data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function findIntegration(id) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.findIntegration(id)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function createPropellerAdsIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createPropellerAdsIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function updatePropellerAdsIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updatePropellerAdsIntegration(id, data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function createExoClickIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createExoClickIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch(alertActions.error(error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateExoClickIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateExoClickIntegration(id, data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch(alertActions.error(error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function createMondiadIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createMondiadIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch(alertActions.error(error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateMondiadIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateMondiadIntegration(id, data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch(alertActions.error(error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function createClickBankIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createClickBankIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch(alertActions.error(error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateClickBankIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateClickBankIntegration(id, data).catch((error) => {
            dispatch(alertActions.error(error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createSedoIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createSedoIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Sedo is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Sedo integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateSedoIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateSedoIntegration(id, data).then(() => {
            dispatch(alertActions.success("Bodis integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Sedo integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createSystem1Integration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createSystem1Integration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("System1 is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("System1 integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateSystem1Integration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateSystem1Integration(id, data).then(() => {
            dispatch(alertActions.success("System1 integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("System1 integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function getGoogleLoginLink(renewIntegrationId) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_GOOGLE_LOGIN_LINK_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getGoogleLoginLink(renewIntegrationId)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_GOOGLE_LOGIN_LINK, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function getRenewableGoogleLoginLink(renewIntegrationId) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_INTEGRATIONS_VIEW_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getGoogleLoginLink(renewIntegrationId)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_RENEWABLE_GOOGLE_LOGIN_LINK, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function googleCallback(code, state) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.googleCallback(code, state)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error("Google integration failed: " + error?.response?.data?.error));
            }
        );
    };
}

function getGoogleAdAccounts(id) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AD_ACCOUNTS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getGoogleAdAccounts(id)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_AD_ACCOUNTS, result: {result: result}});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function integrateGoogleAdAccount(
    {adAccountId, adAccountName, adAccountTimezone, adAccountCurrencyCode, integrationId}
) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AD_ACCOUNTS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.integrateGoogleAdAccount({
            adAccountId, adAccountName, adAccountTimezone, adAccountCurrencyCode, integrationId
        }).then(() => {
            dispatch({type: integrationConstants.INTEGRATIONS_SET_AD_ACCOUNT_INTEGRATED, adAccountId});
        }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error("Google ad account integration failed: " + error?.response?.data?.error));
            }
        );
    };
}

function integrateGoogleConversionAPI({integrationId = 0, enableConversionAPI = false, mccAdAccountId = "", events = []}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.integrateGoogleConversionAPI({
            integrationId, mccAdAccountId, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("Google Ads is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("Google Ads integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function getMicrosoftLoginLink(renewIntegrationId) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_MICROSOFT_LOGIN_LINK_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getMicrosoftLoginLink(renewIntegrationId)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_MICROSOFT_LOGIN_LINK, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function getRenewableMicrosoftLoginLink(renewIntegrationId) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_INTEGRATIONS_VIEW_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getMicrosoftLoginLink(renewIntegrationId)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_RENEWABLE_MICROSOFT_LOGIN_LINK, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function microsoftCallback(code, state) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.microsoftCallback(code, state)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error("Microsoft integration failed: " + error?.response?.data?.error));
            }
        );
    };
}

function getMicrosoftAdAccounts(id) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AD_ACCOUNTS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getMicrosoftAdAccounts(id)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_AD_ACCOUNTS, result: {result: result}});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function integrateMicrosoftAdAccount({accountId, integrationId, customerId}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AD_ACCOUNTS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.integrateMicrosoftAdAccount({accountId, integrationId, customerId}).then(() => {
            dispatch({type: integrationConstants.INTEGRATIONS_SET_MICROSOFT_AD_ACCOUNT_INTEGRATED, accountId});
        }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error("Microsoft Ads ad account integration failed: " + error?.response?.data?.error));
            }
        );
    };
}

function integrateMicrosoftConversionAPI({integrationId = 0, enableConversionAPI = false, events = []}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.integrateMicrosoftConversionAPI({
            integrationId, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("Microsoft Ads is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("Microsoft Ads integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function createBodisIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createBodisIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Bodis is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Bodis integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateBodisIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateBodisIntegration(id, data).then(() => {
            dispatch(alertActions.success("Bodis integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Bodis integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createDomainActiveIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createDomainActiveIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Domain Active is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Domain Active integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateDomainActiveIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateDomainActiveIntegration(id, data).then(() => {
            dispatch(alertActions.success("Domain Active integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Domain Active integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createAdsComIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createAdsComIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Ads.com is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Ads.com integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateAdsComIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateAdsComIntegration(id, data).then(() => {
            dispatch(alertActions.success("Ads.com integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Ads.com integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createTonicIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createTonicIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Tonic is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Tonic integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateTonicIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateTonicIntegration(id, data).then(() => {
            dispatch(alertActions.success("Tonic integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Tonic integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createShopifyIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createShopifyIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Shopify is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Shopify integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateShopifyIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateShopifyIntegration(id, data).then(() => {
            dispatch(alertActions.success("Shopify integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Shopify integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function getTaboolaAdAccounts({apiClient, apiSecret, integrationId}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AD_ACCOUNTS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getTaboolaAdAccounts({apiClient, apiSecret, integrationId})
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_AD_ACCOUNTS, result: {result: result}});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function createTaboolaIntegration({
                                      name,
                                      apiClient,
                                      apiSecret,
                                      accountId,
                                      currency,
                                      timezone,
                                      enableConversionAPI = false,
                                      events = []
                                  }) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.createTaboolaIntegration({
            name, apiClient, apiSecret, accountId, currency, timezone, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("Taboola is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("Taboola integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function updateTaboolaIntegration(
    {
        integrationId = 0,
        name,
        apiClient,
        apiSecret,
        accountId,
        currency,
        timezone,
        enableConversionAPI = false,
        events = []
    }
) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.updateTaboolaIntegration(integrationId, {
            name, apiClient, apiSecret, accountId, currency, timezone, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("Taboola integration is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("Updating Taboola integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function createMgidIntegration({name, apiClient, apiSecret, enableConversionAPI = false, events = []}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.createMgidIntegration({
            name, apiClient, apiSecret, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("MGID is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("MGID integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function updateMgidIntegration(
    {integrationId = 0, name, apiClient, apiSecret, enableConversionAPI = false, events = []}
) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.updateMgidIntegration(integrationId, {
            name, apiClient, apiSecret, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("MGID integration is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("Updating MGID integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function createOutbrainIntegration({
                                       name,
                                       apiToken,
                                       adAccountId,
                                       adAccountName,
                                       currency,
                                       enableConversionAPI = false,
                                       events = []
                                   }) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.createOutbrainIntegration({
            name, apiToken, adAccountId, adAccountName, currency, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("Outbrain is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("Outbrain integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function updateOutbrainIntegration(
    {integrationId = 0, name, apiToken, adAccountId, adAccountName, currency, enableConversionAPI = false, events = []}
) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.updateOutbrainIntegration(integrationId, {
            name, apiToken, adAccountId, adAccountName, currency, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("Outbrain integration is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("Updating Outbrain integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function getOutbrainAdAccounts({apiToken, integrationId}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AD_ACCOUNTS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getOutbrainAdAccounts({apiToken, integrationId})
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_AD_ACCOUNTS, result: {result: result}});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function getTikTokLoginLink(renewIntegrationId) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_TIKTOK_LOGIN_LINK_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getTikTokLoginLink(renewIntegrationId)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_TIKTOK_LOGIN_LINK, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function getRenewableTikTokLoginLink(renewIntegrationId) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_INTEGRATIONS_VIEW_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getTikTokLoginLink(renewIntegrationId)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_RENEWABLE_TIKTOK_LOGIN_LINK, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function tikTokCallback(code, state) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.tikTokCallback(code, state)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error("TikTok integration failed: " + error?.response?.data?.error));
            }
        );
    };
}

function getTikTokAdAccounts(id) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AD_ACCOUNTS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getTikTokAdAccounts(id)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_AD_ACCOUNTS, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function integrateTikTokAdAccount(adAccountId, adAccountName, integrationId) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AD_ACCOUNTS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.integrateTikTokAdAccount(adAccountId, adAccountName, integrationId)
            .then(() => {
                integrationService.getTikTokAdAccounts(integrationId)
                    .then((result) => {
                        dispatch({type: integrationConstants.INTEGRATIONS_SET_AD_ACCOUNTS, result});
                    }).catch((error) => {
                        dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                        dispatch(alertActions.error(error?.response?.data?.error));
                    }
                );
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error("TikTok ad account integration failed: " + error?.response?.data?.error));
            }
        );
    };
}

function integrateTikTokConversionAPI({integrationId = 0, enableConversionAPI = false, events = [], pixels = []}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.integrateTikTokConversionAPI({
            integrationId, enableConversionAPI, events, pixels
        }).then(() => {
            dispatch(alertActions.success("TikTok is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("TikTok integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function smartNewsSetActiveStep(step) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_SMARTNEWS_ACTIVE_STEP, result: {activeStep: step}});
    };
}

function smartNewsConnect({businessId}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.smartNewsConnect({businessId}).then((result) => {
            dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            dispatch({type: integrationConstants.INTEGRATIONS_SMARTNEWS_ACTIVE_STEP, result: {activeStep: 2}});
        }).catch((error) => {
            dispatch({type: integrationConstants.INTEGRATIONS_SMARTNEWS_ERROR, error});
            dispatch(alertActions.error("SmartNews integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function getSmartNewsAdAccounts({integrationId, businessId}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AD_ACCOUNTS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getSmartNewsAdAccounts({integrationId, businessId})
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_AD_ACCOUNTS, result});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function integrateSmartNewsAdAccount({adAccountId, adAccountName, currency, timezone, businessId, integrationId}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_INTEGRATE_AD_ACCOUNT_LOADING_SPINNER, data: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.integrateSmartNewsAdAccount({
            adAccountId,
            adAccountName,
            currency,
            timezone,
            businessId,
            integrationId
        }).then(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_INTEGRATE_AD_ACCOUNT_LOADING_SPINNER,
                data: {loading: false}
            });
            dispatch({type: integrationConstants.INTEGRATIONS_SMARTNEWS_ACTIVE_STEP, result: {activeStep: 3}});
        }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error("SmartNews ad account integration failed: " + error?.response?.data?.error));
            }
        );
    };
}

function integrateSmartNewsConversionAPI({integrationId = 0, enableConversionAPI = false, events = [], pixels = []}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.integrateSmartNewsConversionAPI({
            integrationId, enableConversionAPI, events, pixels
        }).then(() => {
            dispatch(alertActions.success("SmartNews is successfully integrated."));
            dispatch({type: integrationConstants.INTEGRATIONS_SMARTNEWS_CONVERSION_API_SUCCESS});
        }).catch((error) => {
            dispatch({type: integrationConstants.INTEGRATIONS_SMARTNEWS_CONVERSION_API_ERROR, error});
            dispatch(alertActions.error("SmartNews integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function getRsocIntegrations() {
    return (dispatch, getState) => {
        if (getState().integration.loading.rsocIntegrations) return;
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_RSOC_INTEGRATIONS_SPINNER});
        integrationService.getIntegrations({category: "rsoc"})
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_RSOC_INTEGRATIONS, result});
            }).catch((error) => {
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function getServerIntegrations() {
    return (dispatch, getState) => {
        if (getState().integration.loading.serverIntegrations) return;
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_SERVER_INTEGRATIONS_SPINNER});
        integrationService.getIntegrations({category: "server"})
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_SERVER_INTEGRATIONS, result});
            }).catch((error) => {
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function createRsocSystem1Integration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createRsocSystem1Integration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Rsoc System1 is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Rsoc System1 integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateRsocSystem1Integration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateRsocSystem1Integration(id, data).then(() => {
            dispatch(alertActions.success("Rsoc System1 integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Rsoc System1 integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createRsocInuvoIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createRsocInuvoIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("RSOC Inuvo is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("RSOC Inuvo integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateRsocInuvoIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateRsocInuvoIntegration(id, data).then(() => {
            dispatch(alertActions.success("RSOC Inuvo integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("RSOC Inuvo integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createRsocAMGIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createRsocAMGIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("RSOC AMG is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("RSOC AMG integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateRsocAMGIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateRsocAMGIntegration(id, data).then(() => {
            dispatch(alertActions.success("RSOC AMG integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("RSOC AMG integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createServerAwsIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createServerAwsIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("AWS API is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("AWS API integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateServerAwsIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateServerAwsIntegration(id, data).then(() => {
            dispatch(alertActions.success("AWS API integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("AWS API integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createDomainCloudflareIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createDomainCloudflareIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Cloudflare API is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Cloudflare API integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateDomainCloudflareIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateDomainCloudflareIntegration(id, data).then(() => {
            dispatch(alertActions.success("Cloudflare API integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Cloudflare API integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createDomainNamesiloIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createDomainNamesiloIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Namesilo API is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Namesilo API integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateDomainNamesiloIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateDomainNamesiloIntegration(id, data).then(() => {
            dispatch(alertActions.success("Namesilo API integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Namesilo API integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createRevContentIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createRevContentIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch(alertActions.error(error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateRevContentIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateRevContentIntegration(id, data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
            }).catch((error) => {
                dispatch(alertActions.error(error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function createRsocAdsComIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createRsocAdsComIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Ads.com is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Ads.com integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateRsocAdsComIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateRsocAdsComIntegration(id, data).then(() => {
            dispatch(alertActions.success("RSOC Ads.com integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("RSOC Ads.com integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createRsocPredictoIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createRsocPredictoIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Predicto.ai is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Predicto.ai integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateRsocPredictoIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateRsocPredictoIntegration(id, data).then(() => {
            dispatch(alertActions.success("Predicto.ai integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Predicto.ai integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createRsocAirfindIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createRsocAirfindIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Airfind is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Airfind integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateRsocAirfindIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateRsocAirfindIntegration(id, data).then(() => {
            dispatch(alertActions.success("Airfind integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Airfind integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createRsocPricesIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createRsocPricesIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Prices is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Prices integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateRsocPricesIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateRsocPricesIntegration(id, data).then(() => {
            dispatch(alertActions.success("Prices integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Prices integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createRsocInuvoPrismIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createRsocInuvoPrismIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Inuvo Prism is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Inuvo Prism integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateRsocInuvoPrismIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateRsocInuvoPrismIntegration(id, data).then(() => {
            dispatch(alertActions.success("Inuvo Prism integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Inuvo Prism integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createRsocTonicIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createRsocTonicIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Tonic is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Tonic integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateRsocTonicIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateRsocTonicIntegration(id, data).then(() => {
            dispatch(alertActions.success("Tonic integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Tonic integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createRsocExploradsIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createRsocExploradsIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("ExplorAds is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("ExplorAds integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateRsocExploradsIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateRsocExploradsIntegration(id, data).then(() => {
            dispatch(alertActions.success("ExplorAds integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("ExplorAds integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createRsocSedoIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createRsocSedoIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Sedo RSOC is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Sedo RSOC integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateRsocSedoIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateRsocSedoIntegration(id, data).then(() => {
            dispatch(alertActions.success("Sedo RSOC integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Sedo RSOC integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createRsocVisymoIntegration(data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.createRsocVisymoIntegration(data)
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_CURRENT_INTEGRATION, result});
                dispatch(alertActions.success("Visymo RSOC is successfully integrated."));
            }).catch((error) => {
                dispatch(alertActions.error("Visymo RSOC integration failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}

function updateRsocVisymoIntegration(id, data) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.updateRsocVisymoIntegration(id, data).then(() => {
            dispatch(alertActions.success("Visymo RSOC integration is successfully updated."));
        }).catch((error) => {
            dispatch(alertActions.error("Visymo RSOC integration update failed: " + error?.response?.data?.error));
            dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
        });
    };
}

function createOutbrainDSPIntegration(
    {
        name, clientId, clientSecret, adAccountId, adAccountName, currency, enableConversionAPI = false, events = []
    }
) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.createOutbrainDSPIntegration({
            name, clientId, clientSecret, adAccountId, adAccountName, currency, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("Outbrain DSP is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("Outbrain DSP integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function updateOutbrainDSPIntegration(
    {
        integrationId = 0,
        name,
        clientId,
        clientSecret,
        adAccountId,
        adAccountName,
        currency,
        enableConversionAPI = false,
        events = []
    }
) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.updateOutbrainDSPIntegration(integrationId, {
            name, clientId, clientSecret, adAccountId, adAccountName, currency, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("Outbrain DSP integration is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("Updating Outbrain DSP integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function getOutbrainDSPAdAccounts({clientId, clientSecret, integrationId}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AD_ACCOUNTS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getOutbrainDSPAdAccounts({clientId, clientSecret, integrationId})
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_AD_ACCOUNTS, result: {result: result}});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function getNewsBreakAdAccounts({accessToken, organizationId, integrationId}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AD_ACCOUNTS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getNewsBreakAdAccounts({accessToken, organizationId, integrationId})
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_AD_ACCOUNTS, result: {result: result}});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function createNewsBreakIntegration(
    {
        name,
        accessToken,
        organizationId,
        adAccountId,
        adAccountName,
        currency,
        enableConversionAPI = false,
        events = []
    }
) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.createNewsBreakIntegration({
            name, accessToken, organizationId, adAccountId, adAccountName, currency, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("NewsBreak is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("NewsBreak integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function updateNewsBreakIntegration(
    {
        integrationId = 0,
        name,
        accessToken,
        organizationId,
        adAccountId,
        adAccountName,
        currency,
        enableConversionAPI = false,
        events = []
    }
) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.updateNewsBreakIntegration(integrationId, {
            name, accessToken, organizationId, adAccountId, adAccountName, currency, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("NewsBreak integration is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("Updating NewsBreak integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function createMediaGoIntegration(
    {
        name, apiKey, adAccountId, adAccountName, currency, enableConversionAPI = false, events = []
    }
) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.createMediaGoIntegration({
            name, apiKey, adAccountId, adAccountName, currency, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("MediaGo is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("MediaGo integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function updateMediaGoIntegration(
    {
        integrationId = 0,
        name,
        apiKey,
        adAccountId,
        adAccountName,
        currency,
        enableConversionAPI = false,
        events = []
    }
) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.updateMediaGoIntegration(integrationId, {
            name, apiKey, adAccountId, adAccountName, currency, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("MediaGo integration is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("Updating MediaGo integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function getMediaGoAdAccounts({apiKey, integrationId}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_AD_ACCOUNTS_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.getMediaGoAdAccounts({apiKey, integrationId})
            .then((result) => {
                dispatch({type: integrationConstants.INTEGRATIONS_SET_AD_ACCOUNTS, result: {result: result}});
            }).catch((error) => {
                dispatch({type: integrationConstants.INTEGRATIONS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function createPopinIntegration(
    {
        name, apiKey, adAccountId, adAccountName, currency, enableConversionAPI = false, events = []
    }
) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.createPopinIntegration({
            name, apiKey, adAccountId, adAccountName, currency, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("Popin is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("Popin integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}

function updatePopinIntegration(
    {
        integrationId = 0,
        name,
        apiKey,
        adAccountId,
        adAccountName,
        currency,
        enableConversionAPI = false,
        events = []
    }
) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER, result: {loading: true}});
        dispatch(alertActions.error(""));
        integrationService.updatePopinIntegration(integrationId, {
            name, apiKey, adAccountId, adAccountName, currency, enableConversionAPI, events
        }).then(() => {
            dispatch(alertActions.success("Popin integration is successfully integrated."));
        }).catch((error) => {
            dispatch(alertActions.error("Updating Popin integration failed: " + error?.response?.data?.error));
        }).finally(() => {
            dispatch({
                type: integrationConstants.INTEGRATIONS_CONVERSION_API_LOADING_SPINNER,
                result: {loading: false}
            });
        });
    };
}


function removeIntegrationEventFromCurrentIntegration({eventId, integrationId}) {
    return (dispatch) => {
        dispatch({type: integrationConstants.INTEGRATIONS_LOADING_CURRENT_INTEGRATION_SPINNER});
        dispatch(alertActions.error(""));
        integrationService.deleteIntegrationEvent({integrationId, eventId}).then(() => {
            dispatch({type: integrationConstants.INTEGRATIONS_REMOVE_CURRENT_INTEGRATION_EVENT, payload: {eventId, integrationId}});
        }).catch((error) => {
                dispatch(alertActions.error("Removing event failed: " + error?.response?.data?.error));
                dispatch({type: integrationConstants.INTEGRATIONS_STOP_LOADING_CURRENT_INTEGRATION_SPINNER});
            }
        );
    };
}
